<div class="margin-top" [formGroup]="group" [ngClass]="field.class">
  <ion-item>
    <ion-label color="primary">{{ field.label }}</ion-label>
    <ion-datetime-button
      datetime="{{ 'date-time-picker' + field.name }}"
    ></ion-datetime-button>

    <!-- Validation Errors -->
    @for (validation of field.validations; track validation) {
      <div class="validation-error">
        @if (group.get(field.name || 'date')?.hasError(validation.name)) {
          <ion-text color="danger">{{ validation.message }}</ion-text>
        }
      </div>
    }
  </ion-item>

  <ion-modal [keepContentsMounted]="true">
    <ng-template>
      <ion-datetime
        [id]="'date-time-picker' + field.name"
        displayFormat="MM/DD/YYYY"
        presentation="date"
        [preferWheel]="true"
        [value]="fieldValue"
      ></ion-datetime>
    </ng-template>
  </ion-modal>
</div>
